
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const marketVolatilityChallenge: Challenge = {
  id: 'market-volatility',
  title: 'Extreme Market Volatility',
  description: 'Bitcoin price is experiencing unprecedented volatility. How will you manage your operation?',
  options: [
    {
      text: 'Implement hedging strategies',
      outcome: 'Your financial protections maintained stability despite market chaos.',
      kpiEffects: {
        profitMargin: 4,
        efficiency: -1
      },
      experienceGain: 35,
      skillUnlock: skills.find(s => s.id === 'hedging-strategies')
    },
    {
      text: 'Increase mining intensity',
      outcome: 'You maximized production during volatility, but at increased operational strain.',
      kpiEffects: {
        efficiency: 3,
        uptime: -3,
        energyCost: 0.01
      },
      experienceGain: 25
    },
    {
      text: 'Diversify business operations',
      outcome: 'You created additional revenue streams, increasing stability at some cost to focus.',
      kpiEffects: {
        profitMargin: 2,
        efficiency: -2,
        uptime: 1
      },
      experienceGain: 30
    }
  ],
  difficulty: 4,
  requiredSkills: ['market-analysis']
}
